// @ts-nocheck
import { FC, useState, useEffect, ReactNode, Key } from 'react';
import { ProForm, ProInput, ProSelect } from '../antd';
import TextAreaRow from '../TextAreaRow';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { FormItemProps } from 'antd/lib/form';
import { InputProps } from 'antd/lib/input';
import { SelectProps } from 'antd/lib/select';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export type modeType = 'tags';
export interface SelectInputOptionType {
  mode?: modeType;
  label?: ReactNode;
  value?: Key;
  disabled?: boolean;
  className?: string;
}
export interface SelectInputSelectProps
  extends Omit<SelectProps<any>, 'options'> {
  options: SelectInputOptionType[];
}
export interface SearchFormSelectInputProps extends BaseSearchFormItemProps {
  /** select Props */
  selectProps?: SelectInputSelectProps;
  /** input Props */
  inputProps?: InputProps;
  /** 下拉form表单配置 */
  preFormItemProps?: FormItemProps;
}
/** 下拉+文本框组合 */
export const SearchFormSelectInput: FC<SearchFormSelectInputProps> = props => {
  const {
    inputProps,
    selectProps,
    preFormItemProps,
    isDetail,
    form,
    isTable,
    testId,
    label,
    rules,
    hideLabel,
    render,
    disabledRender,
    ...resProps
  } = props;
  const [inputDisabled, setInputDisabled] = useState(true);
  const [selectMode, setSelectMode] = useState<modeType>();
  let prefixSelector: ReactNode = null;
  const inputName: string = resProps.name as string;
  const selectName: string = preFormItemProps
    ? (preFormItemProps.name as string)
    : '';
  const handleChange = (value: any, option: any) => {
    const mode = option.mode;
    form?.setFieldsValue({ [inputName]: undefined });
    setSelectMode(mode);
    setInputDisabled(false);
  };
  if (selectProps) {
    prefixSelector = (
      <ProForm.Item noStyle {...preFormItemProps}>
        <ProSelect
          onChange={handleChange}
          {...selectProps}
          placeholder={getSelectPlaceholder(label, selectProps, rules)}
          test-id={`${testId}-${selectName}`}
          // options={}
        />
      </ProForm.Item>
    );
  }
  useEffect(() => {
    setTimeout(() => {
      const selectValue = (form && preFormItemProps) ? form.getFieldValue(preFormItemProps.name as string) : '';
      if (selectValue) {
        setInputDisabled(false);
      }
    }, 200);
  }, []);
  const renderFormItem = (): ReactNode => {
    if (selectMode === 'tags') {
      return (
        <TextAreaRow addonBefore={prefixSelector} disabled={inputDisabled} />
      );
    }
    return (
      <ProInput
        addonBefore={prefixSelector}
        disabled={inputDisabled}
        test-id={`${testId}-${inputName}`}
        className='select-before-input'
        placeholder='搜索内容'
        {...inputProps}
      />
    );
  };
  return (
    <SearchFormItem {...resProps} label={!hideLabel && label} rules={rules}>
      {isDetail || (inputProps && inputProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          render={render || disabledRender}
          names={[
            { name: selectName, options: selectProps?.options },
            { name: inputName },
          ]}
          isTable={isTable}
        />
      ) : (
        renderFormItem()
      )}
    </SearchFormItem>
  );
};

SearchFormSelectInput.displayName = SearchFormItemEnum.SearchFormSelectInput;

export default SearchFormSelectInput;
